import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Joint Obligations": [
      {
        title: "Liability",
        dataIndex: "Liability",
        key: "liability",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Monthly Payment",
        dataIndex: "Monthly Payment",
        key: "monthlyAmount",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
      },
      {
        title: "Balance",
        dataIndex: "Balance",
        key: "balance",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
        : "N/A",
      },
      actionColumn,
    ],
 
    "Individual Obligations": [
        {
            title: "Liability",
            dataIndex: "Liability",
            key: "liability",
            render: (record) => (record ? record : "N/A"),
          },
          {
            title: "Monthly Payment",
            dataIndex: "Monthly Payment",
            key: "monthlyAmount",
            // render: (record) => (record ? record : "N/A"),
            render: (record) => 
              record !== undefined && record !== null
              ? `$${Number(record).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
            })}`
            : "N/A",
          },
          {
            title: "Balance",
            dataIndex: "Balance",
            key: "balance",
            // render: (record) => (record ? record : "N/A"),
            render: (record) => 
              record !== undefined && record !== null
              ? `$${Number(record).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
            })}`
            : "N/A",
          },
      actionColumn,
    ],
    "Pre Marriage Debt": [
        {
            title: "Liability",
            dataIndex: "Liability",
            key: "liability",
            render: (record) => (record ? record : "N/A"),
          },
          {
            title: "Monthly Payment",
            dataIndex: "Monthly Payment",
            key: "monthlyAmount",
            // render: (record) => (record ? record : "N/A"),
            render: (record) => 
              record !== undefined && record !== null
              ? `$${Number(record).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
            })}`
          : "N/A",
          },
          {
            title: "Balance",
            dataIndex: "Balance",
            key: "balance",
            // render: (record) => (record ? record : "N/A"),
            render: (record) => 
              record !== undefined && record !== null
              ? `$${Number(record).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
            })}`
          : "N/A",
          },
      actionColumn,
    ],
  };
};
